module.exports = __webpack_public_path__ + "static/media/Diana_Paola_Espinosa_Fuentes.ef834bb6.png";